import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobEditRequirementsPage from '@/features/jobs/job-edit-requirements/JobEditRequirementsPage';

export const jobEditRequirementsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/requisitos',
  component: JobEditRequirementsPage,
});
